<template>
  <section>

    <v-dialog
      v-model="warningDialog"
      max-width="500">
      <v-card>
        <v-card-title class="headline">Atenção</v-card-title>

        <v-card-text>
          Deseja Remover o Parametro Técnico? Essa ação não poderá ser desfeita.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error darken-2"
            flat
            @click="warningDialog = false">
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-2"
            flat
            @click="remove()"
          >
            Prosseguir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn flat icon>
      <v-icon small @click="warningDialog = true">mdi-delete</v-icon>
    </v-btn>
  </section>
</template>

<script>
import TechnicalParameterService from '@/services/applications/configurations/TechnicalParameterService';

export default {
  name: 'RemoveTypologySize',
  components: {},
  props: ['typology', 'technicalParameterId'],
  data() {
    return {
      warningDialog: false,
    };
  },
  methods: {
    remove() {
      const vm = this;
      this.$store.dispatch('setLoadingDialog', true);
      TechnicalParameterService
        .removeTechnicalParameter(vm.typology.id, vm.technicalParameterId)
        .then(() => {
          vm.$swal({
            title: 'Parâmetro Técnico Removido com Sucesso',
            text: '',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            vm.warningDialog = false;
            vm.typology.technical_parameters.forEach((item, index) => {
              if (item.id === vm.technicalParameterId) {
                vm.typology.technical_parameters.splice(index, 1);
              }
            });
          });
        })
        .catch((err) => {
          this.$swal({
            type: 'error',
            titleText: err.response.data,
          });
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
